interface SkeletonTableProps {
  rows?: number;
  columns?: number;
}

export function SkeletonTable({ rows = 5, columns = 4 }: SkeletonTableProps) {
  return (
    <div className="animate-pulse">
      <div className="flex border-b py-2 px-4 space-x-4">
        {Array.from({ length: columns }).map((_, i) => (
          <div key={i} className="flex-1 h-4 bg-gray-200 rounded" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex border-b py-3 px-4 space-x-4">
          {Array.from({ length: columns }).map((_, c) => (
            <div key={c} className="flex-1 h-3 bg-gray-100 rounded" />
          ))}
        </div>
      ))}
    </div>
  );
}
